export default __webpack_public_path__ + "static/media/rocket_anim_65.be42f5c5.png";